import React from 'react';
import { motion } from 'framer-motion';
import AnalizedCard from './AnalizedCard';
import promo1 from '../../assets/generatedList/1.png';
import promo2 from '../../assets/generatedList/2.png';
import './AiCardsListGenerated.css';

const AiCardsListGenerated = ({ recipe, imageUrl }) => {
  console.log(recipe)
  console.log(imageUrl, recipe)
  if (!recipe) return null;

  return (
    <div className="list-container">
      <motion.div
        className="card-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <AnalizedCard 
          imageUrl={imageUrl || recipe[0]?.imageUrl}
          recipe={recipe}
         />
      </motion.div>

      <motion.div
        className="promo-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.1 }}
      >
        <img className="promo-image" src={promo1} alt="Get Pro Access" />
      </motion.div>

      {/* Закомментированная вторая промо-карточка
      <motion.div
        className="promo-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.2 }}
      >
        <img className="promo-image" src={promo2} alt="Premium Features" />
      </motion.div> */}
    </div>
  );
};

export default AiCardsListGenerated; 